// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__P2slM","title":"CardHeader_title__Sof+h"};